export default "__VITE_ASSET__Xxaacyr0__"